import { render } from "./cookie.vue?vue&type=template&id=a16353b6&bindings={\"consent\":\"options\",\"refuse\":\"options\",\"cookieConsent\":\"options\"}"
import script from "./cookie.vue?vue&type=script&lang=js"
export * from "./cookie.vue?vue&type=script&lang=js"
script.render = render

export default script